import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  phoneInputLabel: {
    defaultMessage: 'Contact Phone Number',
    description: 'Label for the phone number input field in the phone capture form',
    id: 'X24cxa',
  },
  phoneInputPlaceholder: {
    defaultMessage: 'XXX-XXX-XXXX',
    description: 'Placeholder text for the phone number input field',
    id: 'DzgVsr',
  },
  phoneValidationError: {
    defaultMessage: 'Enter a valid phone number',
    description: 'Error message shown when the phone number format is invalid',
    id: 'vVvfvM',
  },
  consentCheckboxLabel: {
    defaultMessage: 'I would like to receive support and updates from ShipStation via SMS.',
    description: 'Label for the SMS consent checkbox in the phone capture form',
    id: 'ajqf7o',
  },
});
